// ----------------------------------------------------------------------

export default function Switch(theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          padding: 0,
          borderRadius: 999,
          width: 50,
          height: 25,
        },
        thumb: {
          boxShadow: theme.customShadows.z1,
        },

        track: {
          opacity: "1 !important",
          backgroundColor: theme.palette.common.white,
          "&.Mui-checked": {
            backgroundColor: `${theme.palette.grey.g6} !important`,
          },
        },
        switchBase: {
          width: 16,
          height: 16,
          backgroundColor: theme.palette.common.black,
          boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.40) , 0px 6px 6px rgba(0, 0, 0, 0.16)",
          top: 3,
          right: 3,
          left: "auto",
          "&:not(:.Mui-checked)": {},
          "&.Mui-checked": {
            transform: "translateX(-25px)",
            backgroundColor: theme.palette.common.white,
            "&:hover": {
              backgroundColor: theme.palette.common.white,
            },
          },

          "&.Mui-disabled+.MuiSwitch-track": {
            opacity: "0.2 !important",
            backgroundColor: `${theme.palette.grey.g6} !important`,
          },
          "&.Mui-checked+.MuiSwitch-track": {
            opacity: 1,
            backgroundColor: "#444444 !important",
          },
          "&:hover": {
            backgroundColor: theme.palette.common.black,
          },
        },
      },
    },
  };
}
